import React from 'react';
import logo from './logo.svg';
import './App.css';
import {Router, Route, Switch} from 'react-router';
import {Provider} from 'react-redux';
import NotFoundPage from "./pages/web/Common/404";
import WelcomePage from "./pages/web/Welcome";
import LoginPage from "./pages/web/Common/LoginPage";
import denied from "./pages/web/Common/denied";

import store from "./redux/store";
import RegisterPage from "./pages/web/Common/RegisterPage";
import SettingDatabaseProjectPage from "./pages/web/Settings/Database/SettingDatabaseProjectPage";
import SettingDatabaseAttributePage from "./pages/web/Settings/Database/SettingDatabaseAttributePage";
import WorkboardDatabaseRecordPage from "./pages/web/Workboard/WorkboardDatabaseRecordPage";
import SettingActivityCreatePage from "./pages/web/Settings/Activities/SettingActivityCreatePage";
import SettingActivityAttributesPage from "./pages/web/Settings/Activities/SettingActivityAttributesPage";
import SettingStageCreatePage from "./pages/web/Settings/Stages/SettingStageCreatePage";
import SettingStageAttributePage from "./pages/web/Settings/Stages/SettingStageAttributePage";
import SettingEntityCreatePage from "./pages/web/Settings/Entities/SettingEntityCreatePage";
import SettingEntityAttributePage from "./pages/web/Settings/Entities/SettingEntityAttributePage";
import UtilProjectCategoryPage from "./pages/web/Settings/Util/UtilProjectCategoryPage";
import UtilProjectStatusPage from "./pages/web/Settings/Util/UtilProjectStatusPage";
import UtilProjectPriorityPage from "./pages/web/Settings/Util/UtilProjectPriorityPage";
import WorkboardActionPage from "./pages/web/Workboard/WorkboardActionPage";
import WorkboardActionPage2 from "./pages/web/Workboard/WorkboardActionPage2";
import SettingUsersManagePage from "./pages/web/Settings/Users/SettingUsersManagePage";
import SettingAllocationUserProjectPage from "./pages/web/Settings/Allocation/SettingAllocationUserProjectPage";
import SettingAllocationUserVoipPage from "./pages/web/Settings/Allocation/SettingAllocationUserVoipPage";
import SettingEntityRecordPage from "./pages/web/Settings/Entities/SettingEntityRecordPage";
import WorkboardLeadPage from "./pages/web/Workboard/WorkboardLeadPage";
import WorkboardLeadPage2 from "./pages/web/Workboard/WorkboardLeadPage2";
import SettingReportDefinePhonePage from "./pages/web/Settings/Report/SettingReportDefinePhonePage";
import SettingReportDefineEmailPage from "./pages/web/Settings/Report/SettingReportDefineEmailPage";
import SettingReportIncidentViewPage from "./pages/web/Settings/Report/SettingReportIncidentViewPage";
import WorkboardViewIncidentPage from "./pages/web/Workboard/WorkboardViewIncidentPage";
import WorkboardViewReminderPage from "./pages/web/Workboard/WorkboardViewReminderPage";
import BackendSocket from "./components/Common/page/Common/BackendSocket";
import WorkboardCallcenterOutboundPage from "./pages/web/Workboard/WorkboardCallcenterOutboundPage";
import WorkboardViewEntitiesPage from "./pages/web/Workboard/WorkboardViewEntitiesPage";
import SettingDatabaseAttributePage2 from "./pages/web/Settings/Database/SettingDatabaseAttributePage2";
import WorkboardReportCdrPage from "./pages/web/Workboard/WorkboardReportCdrPage";
import WorkboardCallcenterLiveCallPage from "./pages/web/Workboard/WorkboardCallcenterLiveCallPage";
import SettingAllocationUserQueue from "./pages/web/Settings/Allocation/SettingAllocationUserQueue";
import WorkboardCallcentreQueueStatusPage from "./pages/web/Workboard/WorkboardCallcentreQueueStatusPage";
import SettingAllocationUserQueuePage from "./pages/web/Settings/Allocation/SettingAllocationUserQueuePage";
import SettingAllocationCompanyToCloudcallPage
    from "./pages/web/Settings/Allocation/SettingAllocationCompanyToCloudcallPage";
import WorkboardExportDateRangePage from "./pages/web/Workboard/WorkboardExportDateRangePage";
import WorkboardInboundCallStatePage from "./pages/web/Workboard/WorkboardInboundCallStatePage";



const createHistory = require("history").createHashHistory;
const history = createHistory();

function App() {
    return (
        <Provider store={store}>
            <BackendSocket>
            <Router history={history}>
                <Switch>
                    <Route exact path="/login" component={LoginPage}/>
                    <Route exact path="/register" component={RegisterPage}/>
                    <Route exact path="/" component={LoginPage}/>


                    <Route exact path="/setting-database-project" component={SettingDatabaseProjectPage}/>
                    <Route exact path="/setting-database-attribute" component={SettingDatabaseAttributePage}/>
                    <Route exact path="/setting-database-attribute2" component={SettingDatabaseAttributePage2}/>
                    <Route exact path="/workboard-database-case" component={WorkboardDatabaseRecordPage}/>

                    <Route exact path="/setting-activity-create" component={SettingActivityCreatePage}/>
                    <Route exact path="/setting-activity-structure" component={SettingActivityAttributesPage}/>

                    <Route exact path="/setting-stage-create" component={SettingStageCreatePage}/>
                    <Route exact path="/setting-stage-structure" component={SettingStageAttributePage}/>

                    <Route exact path="/setting-entity-create" component={SettingEntityCreatePage}/>
                    <Route exact path="/setting-entity-structure" component={SettingEntityAttributePage}/>
                    <Route exact path="/setting-entity-record" component={SettingEntityRecordPage}/>

                    <Route exact path="/setting-util-category" component={UtilProjectCategoryPage}/>
                    <Route exact path="/setting-util-status" component={UtilProjectStatusPage}/>
                    <Route exact path="/setting-util-priority" component={UtilProjectPriorityPage}/>

                    <Route exact path="/workboard-database-new-case" component={WorkboardActionPage} />
                    <Route exact path="/workboard-database-new-case1" component={WorkboardActionPage2} />
                    <Route exact path="/workboard-database-lead" component={WorkboardLeadPage2} />

                    <Route exact path="/setting-user-create" component={SettingUsersManagePage}/>
                    <Route exact path="/setting-allocation-user-project" component={SettingAllocationUserProjectPage}/>
                    <Route exact path="/setting-allocation-user-voip" component={SettingAllocationUserVoipPage}/>
                    <Route exact path="/setting-report-define-phone" component={SettingReportDefinePhonePage}/>
                    <Route exact path="/setting-report-define-email" component={SettingReportDefineEmailPage}/>
                    <Route exact path="/setting-report-view-incident" component={SettingReportIncidentViewPage}/>
                    <Route exact path="/setting-allocation-user-queue" component={SettingAllocationUserQueue}/>
                    <Route exact path="/setting-allocation-manage-queue" component={SettingAllocationUserQueuePage}/>

                    <Route exact path="/setting-allocation-company-cloudcall" component={SettingAllocationCompanyToCloudcallPage}/>

                    <Route exact path="/workboard-view-case" component={WorkboardActionPage}/>
                    <Route exact path="/workboard-view-emergency" component={WorkboardViewIncidentPage}/>
                    <Route exact path="/workboard-view-reminder" component={WorkboardViewReminderPage}/>
                    <Route exact path="/workboard-callcenter-outbound" component={WorkboardCallcenterOutboundPage}/>
                    <Route exact path="/workboard-view-entities" component={WorkboardViewEntitiesPage}/>
                    <Route exact path="/workboard-report-cdr" component={WorkboardReportCdrPage}/>
                    <Route exact path="/workboard-callcenter-live-call" component={WorkboardCallcenterLiveCallPage}/>
                    <Route exact path="/workboard-callcenter-queue-status" component={SettingAllocationUserQueue}/>
                    <Route exact path="/setting-export-date-range" component={WorkboardExportDateRangePage}/>
                    <Route exact path="/setting-inbound-call-state" component={WorkboardInboundCallStatePage}/>

                    <Route exact path="/access-authorize-denied" component={denied}/>
                    <Route exact path="*" component={NotFoundPage}/>
                </Switch>
            </Router>
            </BackendSocket>
        </Provider>
    )
}

export default App;

/*
C100003  easipath
C100019 EFF
 */
